module.exports = __webpack_public_path__ + "static/media/pencil-edit-button-black.a60058a0.svg";